import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Header = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
            <div className="container">
                <Link className="navbar-brand" to="/">RoadTrip</Link>
                <button 
                    className="navbar-toggler" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target="#navbarNav"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav me-auto">
                        <li className="nav-item">
                            <Link className="nav-link" to="/">Accueil</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/roadtrips">Mes Roadtrips</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/new-roadtrip">Nouveau Roadtrip</Link>
                        </li>
                    </ul>
                    <div className="navbar-nav">
                        {user ? (
                            <div className="nav-item dropdown">
                                <a 
                                    className="nav-link dropdown-toggle" 
                                    href="#" 
                                    role="button" 
                                    data-bs-toggle="dropdown"
                                >
                                    {user.email}
                                </a>
                                <ul className="dropdown-menu dropdown-menu-end">
                                    <li>
                                        <a 
                                            className="dropdown-item" 
                                            href="#"
                                            onClick={handleLogout}
                                        >
                                            Déconnexion
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        ) : (
                            <Link className="nav-link" to="/login">Connexion</Link>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Header; 